var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import { ImportContext } from "./importWizard";
export default function ImportWizardNavigation(_a) {
    var hasPrevious = _a.hasPrevious, hasNext = _a.hasNext, hasImport = _a.hasImport, _b = _a.previousLabel, previousLabel = _b === void 0 ? "<< Previous" : _b, _c = _a.nextLabel, nextLabel = _c === void 0 ? "Next >>" : _c, _d = _a.importLabel, importLabel = _d === void 0 ? "Import now" : _d, level = _a.level;
    var importSettings = useContext(ImportContext);
    return (_jsx(_Fragment, { children: _jsx("div", { children: _jsxs("div", __assign({ className: "mt-4 flex flex-row justify-around" }, { children: [hasPrevious && (_jsx("button", __assign({ className: "button primary", onClick: function () {
                            level(importSettings.step - 1);
                        } }, { children: previousLabel }))), hasNext && (_jsx("button", __assign({ className: "button primary", onClick: function () {
                            level(importSettings.step + 1);
                        } }, { children: nextLabel }))), hasImport && (_jsx("button", __assign({ className: "button primary", onClick: function () {
                            level(importSettings.step + 1);
                        } }, { children: importLabel })))] })) }) }));
}
